<template>
  <div
    class="page-content ingredient"
    :class="inventoryDialogAction != '' || action != '' ? 'overhide' : ''"
  >
    <h1 class="page-title">{{ $locale("sideMenu.shop.ingredient") }}</h1>

    <!-- Search Area -->
    <el-row :gutter="10" class="search-area">
      <el-col :span="6">
        <el-row :gutter="10">
          <el-col :span="22">
            <el-input
              :placeholder="$locale('form.plsEnterYourName')"
              v-model="filter.name"
              @keyup.enter.native="filter_fn"
            >
              <i slot="suffix" class="el-input__icon el-icon-search" @click="filter_fn"></i>
            </el-input>
          </el-col>
          <el-col :span="2">
            <el-button class="egl-btn-yellow" @click="filter_fn">{{$locale("global.search")}}</el-button>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="18" class="ta-r">
        <el-button :class="notApprove.length > 0 ? 'egl-btn-yellow' : 'egl-btn-gray'" :disabled="!(notApprove.length > 0)" @click="approveIngredient_fn">{{ $locale("global.approve") }}</el-button>
        <el-button class="egl-btn-yellow" @click="showCreate">{{ $locale("global.create") }}</el-button>
      </el-col>
    </el-row>

    <el-row :gutter="10" class="search-area">
      <el-col :span="24" class="ta-r">
        <el-button class="egl-btn-yellow" @click="exportInventory_fn">{{ $locale("global.inventoryTable") }}</el-button>
        <UploadContainer
          :type="'C'"
          :imageList="[csvList]"
          :uploadBtnText="$locale('global.uploadInventoryTable')"
          :action="uploadInventoryUrl"
          :accept="'.csv'"
          @onSuccess="({response}) => uploadSuccess(response)"
        ></UploadContainer>
        <el-button class="egl-btn-yellow" @click="export_fn">{{ $locale("global.listCSV") }}</el-button>
        <UploadContainer
          :type="'C'"
          :imageList="[csvList]"
          :uploadBtnText="$locale('global.CSVBatchOperation')"
          :action="uploadUrl"
          :accept="'.csv'"
          @onSuccess="({response}) => uploadSuccess(response)"
        ></UploadContainer>
      </el-col>
    </el-row>

    <el-table :data="tableData" class="egl-table list-table" @sort-change="sort_fn" ref="table" stripe>
      <el-table-column :label="$locale('global.change')" width="50" align="center">
        <template slot-scope="scope">
          <i class="el-icon-circle-check change" v-show="!scope.row.isApprove"></i>
        </template>
      </el-table-column>

      <template v-for="th in thead">
        <el-table-column
          v-if="th.sort"
          :prop="th.prop"
          :label="th.label"
          :key="th.prop"
          sortable="custom"
          :min-width="th.width"
          :align="th.align"
        ></el-table-column>
        <el-table-column
          v-else
          :prop="th.prop"
          :label="th.label"
          :key="th.prop"
          :min-width="th.width"
          :align="th.align"
        ></el-table-column>
      </template>

      <el-table-column :label="$locale('global.control')" width="200" align="center">
        <template slot-scope="scope">
          <div class="handle">
            <a @click="showInventoryDialog(scope.row.id, scope.row.name, scope.row.stockQty, scope.row.unit)">{{ $locale("global.inventoryChange") }}</a>
            <el-divider direction="vertical"></el-divider>
            <a @click="showIngredientDetail(scope.row.id, 'edit')">{{ $locale("global.edit") }}</a>
            <el-divider direction="vertical"></el-divider>
            <a @click="deleteIngredient_fn(scope.row.id, scope.$index, scope.row.name)">{{ $locale("global.delete") }}</a>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <CommPagination
      :total="pageCount"
      :curPage="onSearch.page"
      :pageSize="onSearch.pageSize"
      @current-change="choosePage"
    />

    <Dialog
      v-bind:action="action"
      v-bind:detailObj="dailogDetailMsg"
      v-bind:clientList="clientList"
      @closeFn="closeDetailDailog"
      @returnMsg="getDialogMsg"
      v-bind:isEdit="isEdit"
      :brandSetting="brandSetting"
    ></Dialog>

    <InventoryDialog
      v-bind:action="inventoryDialogAction"
      v-bind:tableList="inventoryDetailTable"
      @closeFn="closeInventoryDialog"
      @returnMsg="getInventoryDialogMsg"
    ></InventoryDialog>
  </div>
</template>

<script>
import tranfResData from "@/utils/tranfResData";
import {
  getIngredientList,
  approveIngredient,
  createIngredient,
  getIngredientDetial,
  updateIngredient,
  deleteIngredient,
  updateInventory,
  ingredientInventoryExport,
  ingredientExport,
} from "@/helpers/service/api/ingredient.js";
import { getClientListService } from "@/helpers/service/api/common";
import Dialog from "@/components/Ingredient/Dialog.vue";
import InventoryDialog from "@/components/Ingredient/InventoryDialog.vue";
import { getBrandDetail } from "@/helpers/service/api/brand.js";
import { requestAll } from "@/helpers/service/axiosPlugin";
import countDownAlert from "@/utils/countDownAlert";
import CommPagination from "@/components/common/CommPagination";
import "@/assets/style/ingredient.less";
import UploadContainer from "@/components/common/UploadContainer";

export default {
  name: "Ingredient",
  data() {
    return {
      onSearch: {
        name: "",
        page: 0,
        pageSize: 10
      },
      filter: {
        name: "",
      },
      isEdit: true,
      pageCount: 0,
      thead: [
        {
          prop: "name",
          label: this.$locale("global.name"),
          sort: true,
          width: 300,
        },
        {
          prop: "unit",
          label: this.$locale("global.unit"),
          sort: false,
          width: 100,
          align: "center",
        },
        {
          prop: "stockPriceText",
          label: this.$locale("shop.purchasePriceUnit"),
          sort: false,
          width: 200,
          align: "center",
        },
        {
          prop: "stockQty",
          label: this.$locale("shop.stock"),
          sort: true,
          width: 200,
          align: "center",
        },
        {
          prop: "stockPlace",
          label: this.$locale("shop.stockLocation"),
          sort: true,
          width: 200,
        },
        {
          prop: "clientText",
          label: this.$locale("shop.supplier"),
          sort: true,
          width: 200,
        }
      ],
      tableData: [],
      notApprove: [],
      action: "",
      dailogDetailMsg: {},
      clientList: [],
      cinemaId: "",
      sort: {
        sort: "",
        sortKey: ""
      },
      token: "",
      uploadUrl_original: "/api/ingredient/import/add?cinemaId=",
      uploadUrl: "/api/ingredient/import/add?cinemaId=",
      uploadInventoryUrl_original: "/api/ingredient/inventoryImport?cinemaId=",
      uploadInventoryUrl: "/api/ingredient/inventoryImport?cinemaId=",
      csvList: [],
      inventoryDialogAction: "",
      inventoryDetailTable: [],
      brandSetting: {},
    };
  },
  methods: {
    getIngredientList_fn() {
      let obj = { ...this.onSearch, cinemaId: this.cinemaId };

      if (this.sort.sort != "") {
        obj = { ...obj, ...this.sort };
      }

      return getIngredientList(obj, false, false);
    },
    getClientList_fn() {
      let obj = { page: 0, pageSize: 9999, field: ["id", "name", "clientCode", "groupName", "aliasName"] };

      return getClientListService(obj, false, false);
    },
    getBrandDetail_fn() {
      const brandId = window.localStorage.getItem("brandId");

      if (brandId) {
        return getBrandDetail({ id: brandId });
      }
    },
    getData_fn() {
      const that = this;
      let cinemaId = window.localStorage.getItem("cinemaId") || "";

      if (cinemaId == "") {
        this.$emit("callCinema", "getData_fn");
        return;
      }
      this.cinemaId = cinemaId;
      this.uploadUrl = this.uploadUrl_original + cinemaId;
      this.uploadInventoryUrl = this.uploadInventoryUrl_original + cinemaId;

      requestAll([
        that.getIngredientList_fn(),
        // that.getClientList_fn(),
        
      ]).then(res => {
        const _ingredientList = res[0].data ? res[0].data.data || [] : [];
        // const _clientList = res[1].data ? res[1].data.data || [] : [];
        
        const { dataList, notApprove } = this.formatData(_ingredientList, []);

        that.tableData = dataList;
        // that.pageCount = Math.ceil(res[0].data.count / that.onSearch.pageSize);
        that.pageCount = res[0].data ? res[0].data.count || 0 : 0;
        that.notApprove = notApprove;
        // that.clientList = _clientList;

        
        // mapping clientName
        const _ids = res[0].data.data.map(item => item.clientId).filter(client => client);
        // if (_ids.length > 0) {
        //   getClientListService({
        //     page: 0,
        //     pageSize: 9999,
        //     field: ["id", "name"],
        //     ids: _ids,
        //   }).then(res => {
        //     this.tableData.forEach(item => {
        //       const obj = res.data.data.find(client => client.id === item.clientId);
        //       item.clientText = obj ? obj.name : item.clientId;
        //     });
        //   });
        // }
      });
    },
    formatData: (arr, clientArr) => {
      let dataList = [];
      let notApprove = [];

      arr.map(obj => {
        if (!obj.isApprove) {
          notApprove.push(obj.id);
        }

        obj.stockQty = obj.stockQty.toLocaleString();
        obj.stockPriceText = "¥" + obj.stockPrice.toLocaleString();
        obj.clientText = "";

        for (let i = 0; i < clientArr.length; i++) {
          if (obj.clientId == clientArr[i].id) {
            obj.clientText = clientArr[i].name;
            break;
          }
        }

        dataList.push({ ...obj });
      });

      return { dataList, notApprove };
    },
    choosePage(page) {
      this.onSearch = { ...this.onSearch, page: page - 1 };

      this.getData_fn();
    },
    filter_fn() {
      this.onSearch = { ...this.onSearch, ...this.filter, page: 0 };

      this.getData_fn();
    },
    showApprove() {
      this.$refs.approve.toggleApprove();
    },
    approveIngredient_fn() {
      let confirmHtml = `<i class="egl-confirm-question">?</i><span class="result-text">${this.$locale("global.approveAll")}</span>`;

      this.$confirm(confirmHtml, "", {
        dangerouslyUseHTMLString: true,
        showClose: false,
        showCancelButton: true,
        cancelButtonClass: "egl-btn-white",
        cancelButtonText: this.$locale("global.cancel"),
        showConfirmButton: true,
        confirmButtonClass: "egl-btn-yellow",
        confirmButtonText: this.$locale("global.approve"),
        customClass: "egl-confirm",
        closeOnClickModal: false
      })
        .then(() => {
          const cinemaId = window.localStorage.getItem("cinemaId");
          approveIngredient({ cinemaId }).then(res => {
            if (res.success) {
              this.countDown(this.$locale("global.approveSuccessful"));
            }
          }).catch(() => {});
        });
      // if (this.notApprove.length > 0) {
      //   let obj = { cinemaId: this.cinemaId };

      //   approveIngredient(obj).then(res => {
      //     if (res.success) {
      //       this.countDown(this.$locale("global.approveSuccessful"));
      //     }
      //   }).catch(() => {});
      // }
    },
    closeDetailDailog() {
      this.dailogDetailMsg = {};
      this.action = "";
    },
    closeInventoryDialog() {
      this.inventoryDetailTable = [];
      this.inventoryDialogAction = "";
    },
    showInventoryDialog(id, name, num, unit) {
      this.inventoryDetailTable = [ { id, name, num, unit } ];
      this.inventoryDialogAction = "show";
    },
    getDialogMsg(obj) {
      if (this.action == "create") {
        createIngredient({
          ...obj,
          cinemaId: this.cinemaId,
          stockPrice: parseFloat(obj.stockPrice),
          priceWithoutTax: parseFloat(obj.priceWithoutTax),
        }).then(res => {
          if (res.success) {
            this.countDown(this.$locale("global.createSuccessfully"));
            this.closeDetailDailog();
          }
        }).catch(()=> {});
      } else {
        updateIngredient({
          ...obj,
          stockPrice: parseFloat(obj.stockPrice),
          priceWithoutTax: parseFloat(obj.priceWithoutTax),
        }).then(res => {
          if (res.success) {
            this.countDown(this.$locale("global.updateSuccessfully"));
            this.closeDetailDailog();
          }
        }).catch(()=> {});
      }
    },
    getInventoryDialogMsg(obj) {
      let queryString = `id=${obj.id}&inventoryChangeQty=${obj.inventoryChangeQty}&inventoryChangeSupplement=${obj.inventoryChangeSupplement}&inventoryChangeType=${obj.inventoryChangeType}&actualDate=${obj.processingDate}&inventoryType=ingredient`;
      updateInventory(queryString).then(res => {
        if (res.success) {
          this.countDown(this.$locale("global.updateSuccessfully"));
          this.closeInventoryDialog();
        }
      }).catch(()=> {});
    },
    showCreate() {
      this.getBrandDetail_fn().then(res => {
        const _brandDetail = res.data || {};
        const brandDetailData = tranfResData(_brandDetail);
        this.brandSetting = brandDetailData.brandSetting;
        this.action = "create";
      })
    },
    showIngredientDetail(id, action) {
      requestAll([
        getIngredientDetial({ id: id }),
        this.getBrandDetail_fn()
      ]).then(res => {
        if (res[0].success) {
          this.isEdit = res[0].data.edit;
          this.dailogDetailMsg = { ...res[0].data };
        }
        const _brandDetail = res[1].data || {};
        const brandDetailData = tranfResData(_brandDetail);
        this.brandSetting = brandDetailData.brandSetting;
        this.action = action;
      })
    },
    deleteIngredient_fn(id, index, name) {
      const that = this;
      let confirmHtml = `<i class="egl-confirm-question">?</i><span class="result-text">${this.$locale("global.delete")} ${name}</span>`;

      this.$confirm(confirmHtml, "", {
        dangerouslyUseHTMLString: true,
        showClose: false,
        showCancelButton: true,
        cancelButtonClass: "egl-btn-white",
        cancelButtonText: this.$locale("global.cancel"),
        showConfirmButton: true,
        confirmButtonClass: "egl-btn-yellow",
        confirmButtonText: this.$locale("global.delete"),
        customClass: "egl-confirm",
        closeOnClickModal: false,
      }).then(() => {
        deleteIngredient({ id }).then(res => {
          if (res.success) {
            that.countDown(this.$locale("global.deleteSuccessfully"));
            this.closeDetailDailog();
          }
        }).catch(()=> {});
      }).catch(() => {});
    },
    export_fn() {
      ingredientExport({
        cinemaId: this.cinemaId,
        page: 0,
        pageSize: 9999,
        name: this.filter.name,
      }).then(res => {
        const bom = new Uint8Array([0xEF, 0xBB, 0xBF]); // UTF-8 BOM
        const content = new TextEncoder().encode(res);
        const blob = new Blob([ bom, content ], { type: 'text/csv;charset=utf-8;' });
        const blobUrl = window.URL.createObjectURL(blob);
        const aElement = document.createElement("a");
        aElement.href = blobUrl;
        aElement.download = `${this.$locale("global.productSalesList")}.csv`;
        aElement.click();
        window.URL.revokeObjectURL(blobUrl);
      });
    },
    exportInventory_fn() {
      ingredientInventoryExport({
        cinemaId: this.cinemaId,
        page: 0,
        pageSize: 9999,
      }).then(res => {
        const bom = new Uint8Array([0xEF, 0xBB, 0xBF]); // UTF-8 BOM
        const content = new TextEncoder().encode(res);
        const blob = new Blob([ bom, content ], { type: 'text/csv;charset=utf-8;' });
        const blobUrl = window.URL.createObjectURL(blob);
        const aElement = document.createElement("a");
        aElement.href = blobUrl;
        aElement.download = `${this.$locale("global.inventoryTable")}.csv`;
        aElement.click();
        window.URL.revokeObjectURL(blobUrl);
      });
    },
    uploadSuccess(res) {
      if (res.success) {
        this.getData_fn();
      }
      this.csvList = [];
    },
    sort_fn({ prop, order }) {
      let sort = "";
      let sortKey = "";

      if (order == "ascending") {
        sort = "ASC";
        sortKey = prop;
      }

      if (order == "descending") {
        sort = "DESC";
        sortKey = prop;
      }

      if (sortKey == "clientText") {
        sortKey = "clientId";
      }

      this.sort = { sort, sortKey };
      this.getData_fn();
    },
    countDown(str = this.$locale("global.createSuccessfully")) {
      countDownAlert({
        content: str,
        callback: () => {
          this.getData_fn();
        }
      });
    },
  },
  created() {
    getClientListService({
      page: 0,
      pageSize: 20,
      field: ["id", "name"]
    }).then(res => {
      if (res.data && res.data.data) {
        this.clientList = res.data.data;
      }
    });
  },
  mounted() {
    let cinemaId = window.localStorage.getItem("cinemaId") || "";
    const token = window.localStorage.getItem("token");

    this.cinemaId = cinemaId;
    this.uploadUrl = this.uploadUrl_original + cinemaId;
    this.uploadInventoryUrl = this.uploadInventoryUrl_original + cinemaId;
    this.token = token;
    this.getData_fn();
  },
  components: {
    Dialog,
    InventoryDialog,
    CommPagination,
    UploadContainer,
  }
};
</script>
